// This file is automatically generated. Do not edit manually.

import { IsoDateString } from "src/types/dateTime";
import { SalvosCustomerOrderConfirmationPrintResult } from "src/api/generated/tenants/salvos/erp/sales/customerOrder/salvosCustomerOrderConfirmationPrintResult";
import { SalvosCustomerOrderTenantStateHistoryDto } from "src/api/generated/tenants/salvos/erp/sales/customerOrder/salvosCustomerOrderTenantStateHistoryDto";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SalvosCustomerOrderApi {
	export async function setDeliveryDateAgreedDate(args: {
		customerOrderId: number;
		deliveryDateAgreedDate: IsoDateString | null | undefined;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/setDeliveryDateAgreedDate",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				deliveryDateAgreedDate: args.deliveryDateAgreedDate,
			},
		});
		return response as void;
	}

	export async function setCustomerOrderBuildingLicenceDate(args: {
		customerOrderId: number;
		buildingLicenceDate: IsoDateString | null | undefined;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/setCustomerOrderBuildingLicenceDate",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				buildingLicenceDate: args.buildingLicenceDate,
			},
		});
		return response as void;
	}

	export async function setRevenueRecognitionDate(args: {
		customerOrderId: number;
		revenueRecognitionDate: IsoDateString | null | undefined;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/setRevenueRecognitionDate",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				revenueRecognitionDate: args.revenueRecognitionDate,
			},
		});
		return response as void;
	}

	export async function markCustomerOrderToCompleted(args: { customerOrderId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/markCustomerOrderToCompleted",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
			},
		});
		return response as void;
	}

	export async function setFoundationsCompletedManually(args: {
		customerOrderId: number;
		completed: boolean;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/setFoundationsCompletedManually",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				completed: args.completed,
			},
		});
		return response as void;
	}

	export async function printCustomerOrderConfirmationWithBillingPlanCheck(args: {
		customerOrderId: number;
		allowWithoutBillingPlanComparison: boolean;
	}): Promise<SalvosCustomerOrderConfirmationPrintResult> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/printCustomerOrderConfirmationWithBillingPlanCheck",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				allowWithoutBillingPlanComparison: args.allowWithoutBillingPlanComparison,
			},
		});
		return response as SalvosCustomerOrderConfirmationPrintResult;
	}

	export async function getCustomerOrderTenantStateHistory(args: {
		customerOrderId: number;
	}): Promise<SalvosCustomerOrderTenantStateHistoryDto> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/getCustomerOrderTenantStateHistory",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
			},
		});
		return response as SalvosCustomerOrderTenantStateHistoryDto;
	}
}
